import {
  StatusState,
  StatusActionTypes,
  statusesAction,
} from "../../types/status";

const initialState: StatusState = {
  statuses: {},
  loading: false,
  error: null,
};

export const statusesReducer = (
  state: StatusState = initialState,
  action: statusesAction
): StatusState => {
  switch (action.type) {
    case StatusActionTypes.GET_STATUSES: {
      return { ...state, loading: true };
    }
    case StatusActionTypes.GET_STATUSES_SUCCESS: {
      return { ...state, loading: false, statuses: action.payload };
    }
    case StatusActionTypes.GET_STATUSES_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }

    default:
      return state;
  }
};
